var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout mb-20"},[_c('PaymentPromoOld',{attrs:{"banks":_vm.getTopPaymentBanks,"buttonText":_vm.btnText,"userLocation":_vm.userLocation,"enemoUrl":_vm.enemoUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }